import Splide from '@splidejs/splide';

if (document.getElementsByClassName('splide')[0]) {
    initNewsSlider();
}

function initNewsSlider() {
    var entries = document.getElementsByClassName('teaser');
    var current;

    var splide = new Splide('.splide', {
        type: 'loop',
        focus: 'center',
        perPage: 1,
        trimSpace: false,
        pagination: false
    }).mount();

    splide.on('move', function () {
        if (current) {
            console.log(current)
        }

        // Splide#index returns the latest slide index:
        var entry = entries[splide.index];

        if (entry) {
            console.log(entry);
            var hash = entry.getElementsByClassName('post-link')[0].href.split("#")[1];
            switchNewsContent(hash);
            current = entry;
        }

    });

    if (window.location.hash) {
        var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
        switchNewsContent(hash);
    }

    document.addEventListener('click', function (event) {

        if (!event.target.matches('.post-link h3')) return;
        event.preventDefault();
        var hash = event.target.parentNode.href.split("#")[1];
        switchNewsContent(hash);

    }, false);
}

/**
 * Show current news and hide others
 * @param hash
 */
function switchNewsContent(hash) {
    var news = document.querySelectorAll('.' + hash);
    var newsAll = document.querySelectorAll('.news-detail');
    var teaserAll = document.querySelectorAll('.teaser');

    teaserAll.forEach(element => element.classList.remove('active'));
    newsAll.forEach(element => element.classList.remove('active'));
    news.forEach(element => element.classList.add('active'));
}